import CustomModal from '../Modal';
import TextWrapper from '../TextWrapper';

import styles from './ConfirmationModal.module.scss';

export interface ConfirmationModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel?: () => void; // Called on Cancel button
  title: string;
  description: React.ReactNode;
  primaryButtonText?: string;
  secondaryButtonText?: string;
}

const ConfirmationModal = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
  title,
  description,
  primaryButtonText = 'Confirm',
  secondaryButtonText = 'Cancel',
  onCancel
}: ConfirmationModalProps) => {
  return (
    <CustomModal
      modalProps={{
        onClose, // X icon closes modal
        opened: isOpen,
        size: 'xl'
      }}
      header={{
        title
      }}
      primaryButton={{
        text: primaryButtonText,
        onClick: onConfirm,
        isLoading
      }}
      secondaryButton={{
        text: secondaryButtonText,
        onClick: onCancel ?? onClose // fallback to onClose if onCancel not provided
      }}>
      <div className={styles.content}>
        <TextWrapper text={description} variant="heading" fw={500} />
      </div>
    </CustomModal>
  );
};

export default ConfirmationModal;
